module.exports = __webpack_public_path__ + "img/287.5e9d595c.png";